export default "__VITE_ASSET__BacpsKdL__"